import { gql } from '@apollo/client';

export const GET_CLASS_SETTINGS_BY_ID = gql`
  query GetClassSettingsById($input: GetClassByIdInput!) {
    getClassById(input: $input) {
      id
      settings {
        animationAutoPlay
        backgroundVisibility
        translationEnabled
        translationEnabledStudent
        ttsEnabled
      }
    }
  }
`;

export const GET_CLASS_SETTINGS = gql`
  query GetClassSettings($input: GetClassSettingsInput!) {
    getClassSettings(input: $input) {
      animationAutoPlay
      backgroundVisibility
      translationEnabled
      translationEnabledStudent
      ttsEnabled
    }
  }
`;

export const UPDATE_CLASS_SETTINGS = gql`
  mutation UpdateClassSettings($input: UpdateClassSettingsInput!) {
    updateClassSettings(input: $input) {
      id
      settings {
        animationAutoPlay
        backgroundVisibility
        translationEnabled
        translationEnabledStudent
        ttsEnabled
      }
    }
  }
`;
